import { FC } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { IvInfo } from '../../shared/iv-info/iv-info';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';

const InsuranceInactiveDialog: FC = () => {
  const { opened, onClose, isLoading } = useApptRequestIvStatusDialog();

  return (
    <ApptRequestIvStatusDialog opened={opened} title={'Insurance Inactive'}>
      <IvInfo />

      <DialogSubTitle sx={{ margin: '30px 0 20px 0', display: 'block' }}>
        This patient's insurance status returned as “inactive”. Please choose to either manually verify or designate the
        patient as self-pay.
      </DialogSubTitle>

      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(InsuranceInactiveDialog);
